// Vendor imports
const qs = require('qs')
// Client V2 common imports
const { TYPES: modelTypes } = require('shared/model-types')
const { articleProfileHref } = require('client-v2/common/models/article/actions')
const { collectionProfileHref } = require('client-v2/common/models/collection/actions')
const { userProfileHref } = require('client-v2/common/models/user/actions')

function socialShareHref(model, shareType) {
  const path = profilePath(model)
  const utmParams = qs.stringify({
    'utm_source': shareType,
    'utm_medium': 'web',
    'utm_campaign': `${model.type}_profile`,
    'utm_term': 'button'
  })
  const href = `https://mix.com${path}?${utmParams}`
  switch (shareType) {
    case 'facebook': return facebookShareHref(href)
    case 'twitter': return twitterShareHref(href, model)
    case 'pinterest': return pinterestShareHref(href, model)
    case 'email': return emailShareHref(href, model)
    case 'copy': return href
  }
}

// Helpers

function profilePath(model) {
  switch (model.type) {
    case modelTypes.ARTICLE: return articleProfileHref(model)
    case modelTypes.MIX: return collectionProfileHref(model)
    case modelTypes.USER: return userProfileHref(model)
  }
}

function facebookShareHref(href) {
  return (
    '//facebook.com/sharer.php' +
    '?u=' + encodeURIComponent(href)
  )
}

function twitterShareText(href, model) {
  switch (model.type) {
    case modelTypes.ARTICLE: return (
      model.title + ' ' +
      href + ' @getmixapp'
    )
    case modelTypes.MIX: return (
      model.name + ' By ' +
      model.username + ' ' +
      href + ' @getmixapp'
    )
    case modelTypes.USER: return (
      model['display_name'] +
      ' is on Mix at ' +
      href + ' @getmixapp'
    )
  }
}

function twitterShareHref(href, model) {
  const text = twitterShareText(href, model)
  return (
    '//twitter.com/intent/tweet?lang=en' +
    '&text=' + encodeURIComponent(text)
  )
}

function pinterestShareMedia(href, model) {
  switch (model.type){
    case modelTypes.ARTICLE:
      return model.image || model.md5image
    case modelTypes.USER:
      return model['photo_url']
    case 'collection':
      return model.images[0]
  }
}

function pinterestShareHref(href, model) {
  const media = pinterestShareMedia(href, model)
  return (
    '//pinterest.com/pin/create/button/' +
    '?url=' + encodeURIComponent(href) +
    '&media=' + encodeURIComponent(media)
  )
}

function emailShareParams(href, model) {
  switch (model.type) {
    case modelTypes.ARTICLE: return {
      subject: 'Check out this article on Mix',
      body: (
        'Heyo, \r\n\r\n' +
        'Check out "' + model.title + '" ' +
        'on Mix at ' + href
      )
    }
    case modelTypes.MIX: return {
      subject: 'Check out this collection on Mix',
      body: (
        'Heyo, \r\n\r\n' +
        'Check out "' + model.name + '" ' +
        'by ' + model.username + ' ' +
        'on Mix at ' + href
      )
    }
    case modelTypes.USER: return {
      subject: 'Check out this cool person on Mix',
      body: (
        'Heyo, \r\n\r\n' +
        model['display_name'] + ' is on Mix at ' + href
      )
    }
  }
}

function emailShareHref(href, model) {
  const { subject, body } = emailShareParams(href, model)
  return (
    'mailto:?subject=' + encodeURIComponent(subject) +
    '&body=' + encodeURIComponent(body)
  )
}

// Exports

module.exports = {
  socialShareHref
}
